import './CRUDProperty.scss';
import Component from './CRUDProperty.js';
export default Component;
